import { watch } from 'vue'

/** Réponse de départ à « Locaux accessibles PMR ? » dans le tunnel. */
export const PMR_PAR_DEFAUT = 'non_concerne'

/**
 * « LOCAUX ACCESSIBLES PMR ? » PART SUR « NON CONCERNÉ » dans l'analyse du
 * besoin (retour Figma du 2026-10-05 : « pour gagner du temps »).
 *
 * PROPRE AU TUNNEL, À L'ÉCRAN COMME EN BASE :
 *  — le schéma partagé n'est pas touché : y changer le départ rendrait la
 *    question facultative dans le questionnaire du client (`blocksValidation`) ;
 *  — un départ que personne n'a modifié n'est PAS enregistré comme une
 *    réponse : l'analyse est recopiée dans le questionnaire du client, qui le
 *    recevrait déjà rempli, et le formateur le lirait comme un fait. La
 *    question vide revient sur « Non concerné » à la réouverture.
 *
 * Posé seulement une fois la demande lue : un devis signé se relit tel quel.
 *
 * @param {Object} deps
 * @param {Object} deps.besoinQuestionnaire - Réponses des sections communes.
 * @param {import('vue').Ref<Object|null>} deps.quote - La demande.
 * @param {import('vue').Ref<boolean>} deps.isQuoteSigned - Devis signé.
 */
export function useBesoinPmrParDefaut({ besoinQuestionnaire, quote, isQuoteSigned }) {
  let poseParLeTunnel = false

  function poserPmrParDefaut() {
    if (besoinQuestionnaire.pmr || !quote.value || isQuoteSigned.value) return
    besoinQuestionnaire.pmr = PMR_PAR_DEFAUT
    poseParLeTunnel = true
  }

  watch(quote, poserPmrParDefaut)

  /** Ce qui part au serveur : rien tant que le départ n'a pas été changé. */
  const pmrAEnregistrer = () => (
    poseParLeTunnel && besoinQuestionnaire.pmr === PMR_PAR_DEFAUT ? '' : besoinQuestionnaire.pmr
  )

  return { poserPmrParDefaut, pmrAEnregistrer }
}
